import { useConfigScopeSelectors } from '../scopes';
import { CultureProvider, IBaseComponentProps } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';
import React from 'react';
import { CoreAppLayoutBase } from '../component/core-app-layout';

export interface ICoreAppLayoutProps extends IBaseComponentProps<HTMLDivElement> {
    routes: React.ReactNode[];
}

const CoreAppLayout = styled(CoreAppLayoutBase)`
    letter-spacing: .1px;
    background-color: white;
    height: 100%;
    width: 100%;
    border: white;
`;

export function CoreAppLayoutContainer(props: ICoreAppLayoutProps) {
    const { selectCulture } = useConfigScopeSelectors('config');
    const culture = selectCulture();
    return (
        <CultureProvider culture={culture}>
            {React.createElement(CoreAppLayout, props)}
        </CultureProvider>
    );
}
